import React, { useEffect } from 'react';
import { IconSchool, IconBook, IconUsers, IconBuildingMosque, IconTrophy, IconWorld, IconTargetArrow, IconTelescope, IconDiamond, IconFlask, IconPresentation, IconBooks, IconShieldCheck, IconLiveView } from '@tabler/icons-react';
import Footer from '../home/footer';

export default function MainAbout() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="font-libre bg-gray-50 min-h-screen">
            {/* Hero Section */}
            <div className="relative w-full h-[400px] md:h-[440px] bg-cover bg-center" style={{ backgroundImage: "url('/assets/about/abouttop.png')" }}>
                <div className="absolute inset-0 bg-black/60"></div>
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
                    <h1 className="text-white text-4xl md:text-6xl font-bold font-AndoraModernSerif mb-4">About Darul Hadees</h1>
                    <h2 className="font-cairo text-pumpkinToast-400 text-xl md:text-3xl font-bold mb-6" style={{ direction: 'rtl' }}>
                        دار الحديث الإسلامية
                    </h2>
                    <p className="text-gray-200 text-lg md:text-xl max-w-5xl">
                        Darul Hadees is a premier Islamic research platform dedicated to bringing reliable and authentic knowledge to the people. Our foundation is built upon the Holy Quran and the Prophetic Tradition (Sunnah), ensuring that every piece of information we share is accurate, clear, and evidence-based.                    </p>
                </div>
            </div>

            {/* Main Content Container */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-20">

                {/* Who We Are Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                    <div className="space-y-6">
                        <span className="text-pumpkinToast-600 font-bold tracking-wider uppercase text-sm">Our Core Philosophy</span>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 font-AndoraModernSerif">
                            A Beacon of Islamic Excellence
                        </h2>
                        <p className="text-gray-600 leading-relaxed text-lg">

                            What distinguishes Islam from other ideologies is its divine principles, free from human interference.
                            We believe that:
                            The <span className="font-bold">Sunnah</span> is integral to analyzing and implementing the true essence of human life.
                            <span className="font-bold">Prophetic Teachings</span> are the key to becoming a better social being and achieving success in both worlds.
                            <span className="font-bold">Authentic Study</span> is the only way to dispel doubts and counter the misinterpretations spreading in the modern context.
                        </p>
                        <p className="text-gray-600 leading-relaxed text-lg mt-0">
                            Our holistic approach ensures that students are not only well-versed in religious texts but also equipped with the moral compass to navigate the modern world.
                        </p>
                    </div>
                    <div className="relative">
                        {/* Decorative element */}
                        <div className="absolute -inset-4 bg-pumpkinToast-100 rounded-lg transform rotate-2 z-0"></div>
                        <img
                            src="/assets/building_9_16.jpeg"
                            alt="About Darul Hadees"
                            className="relative rounded-lg shadow-xl w-full h-[400px] object-cover z-10"
                        />
                    </div>
                </div>

                {/* Vision & Mission Section */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {/* Vision */}
                        <div className="space-y-4">
                            <div className="w-12 h-12 bg-pumpkinToast-100 rounded-full flex items-center justify-center text-pumpkinToast-600">
                                <IconTelescope size={28} stroke={1.5} />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 font-AndoraModernSerif">Our Vision</h3>
                            <p className="text-gray-600 leading-relaxed">
                                To become a leading global center for systematic Hadith research and an intellectual shield against the misinterpretations of Islamic principles.

                            </p>
                        </div>

                        {/* Mission */}
                        <div className="space-y-4">
                            <div className="w-12 h-12 bg-pumpkinToast-100 rounded-full flex items-center justify-center text-pumpkinToast-600">
                                <IconTargetArrow size={28} stroke={1.5} />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 font-AndoraModernSerif">Our Mission</h3>
                            <p className="text-gray-600 leading-relaxed">
                                To provide authentic and evidence-based Islamic knowledge derived from the Holy Quran and the Prophetic Sunnah, making it accessible and understandable for the modern generation.

                            </p>
                        </div>
                    </div>
                </div>

                {/* Stats Section
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center py-8 border-y border-gray-200">
                    <div className="space-y-2">
                        <div className="text-4xl font-bold text-pumpkinToast-600 font-AndoraModernSerif">25+</div>
                        <div className="text-sm text-gray-500 font-medium uppercase tracking-wide">Years established</div>
                    </div>
                    <div className="space-y-2">
                        <div className="text-4xl font-bold text-pumpkinToast-600 font-AndoraModernSerif">1000+</div>
                        <div className="text-sm text-gray-500 font-medium uppercase tracking-wide">Students</div>
                    </div>
                    <div className="space-y-2">
                        <div className="text-4xl font-bold text-pumpkinToast-600 font-AndoraModernSerif">50+</div>
                        <div className="text-sm text-gray-500 font-medium uppercase tracking-wide">Expert Faculty</div>
                    </div>
                    <div className="space-y-2">
                        <div className="text-4xl font-bold text-pumpkinToast-600 font-AndoraModernSerif">100%</div>
                        <div className="text-sm text-gray-500 font-medium uppercase tracking-wide">Success Rate</div>
                    </div>
                </div> */}

                {/* Why Choose Us / Values */}
                <div className="space-y-12">
                    <div className="text-center max-w-3xl mx-auto space-y-4">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 font-AndoraModernSerif">
                            Our Values
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {/* Card 1 */}
                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                            <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-6">
                                <IconDiamond size={32} stroke={1.5} />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">Authenticity</h3>
                            <p className="text-gray-600">
                                Integrity in scholarly research.                            </p>
                        </div>

                        {/* Card 2 */}
                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                            <div className="w-14 h-14 bg-green-50 text-green-600 rounded-lg flex items-center justify-center mb-6">
                                <IconDiamond size={32} stroke={1.5} />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">Intellectualism</h3>
                            <p className="text-gray-600">
                                Addressing doubts with evidence and logic.                            </p>
                        </div>

                        {/* Card 3 */}
                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                            <div className="w-14 h-14 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center mb-6">
                                <IconDiamond size={32} stroke={1.5} />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">Inclusivity</h3>
                            <p className="text-gray-600">
                                Bringing knowledge from scholars to the common man                            </p>
                        </div>
                    </div>
                </div>

                {/* What We Do / Focus Areas Section */}
                <div className="space-y-16 py-10">
                    <div className="text-center max-w-4xl mx-auto space-y-4">
                        <span className="text-pumpkinToast-600 font-bold tracking-[0.2em] uppercase text-xs">Beyond the Website</span>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                            <span className="block font-cairo text-pumpkinToast-500 text-2xl md:text-4xl mb-2" style={{ direction: 'rtl' }}>
                                دار الحديث الإسلامية
                            </span>
                            <span className="block font-AndoraModernSerif">
                                Darul Hadees Islamic Research Center
                            </span>
                        </h2>
                        <p className="text-gray-500 text-lg leading-relaxed mt-6">
                            We are more than just a website; we are a center for systematic and intellectual Hadith study. To make authentic knowledge accessible to everyone, we focus on:
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {/* 01: Research */}
                        <div className="group relative bg-white p-10 rounded-[2.5rem] shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-3 transition-all duration-500 overflow-hidden">
                            <div className="absolute top-0 right-0 p-8 opacity-[0.03] group-hover:opacity-[0.07] transition-opacity">
                                <span className="text-9xl font-black font-AndoraModernSerif">01</span>
                            </div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-blue-600 group-hover:text-white transition-all duration-500 shadow-sm">
                                    <IconFlask size={32} stroke={1.5} />
                                </div>
                                <h3 className="text-2xl font-bold text-[#1f0e56] mb-4 font-AndoraModernSerif">Research & Fellowships</h3>
                                <p className="text-gray-600 leading-relaxed">
                                    Conducting advanced studies in Hadith and Jurisprudence.
                                </p>
                            </div>
                            <div className="absolute bottom-0 left-0 h-1.5 w-0 bg-blue-600 group-hover:w-full transition-all duration-700" />
                        </div>

                        {/* 02: Education */}
                        <div className="group relative bg-white p-10 rounded-[2.5rem] shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-3 transition-all duration-500 overflow-hidden">
                            <div className="absolute top-0 right-0 p-8 opacity-[0.03] group-hover:opacity-[0.07] transition-opacity">
                                <span className="text-9xl font-black font-AndoraModernSerif">02</span>
                            </div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 bg-pumpkinToast-50 text-pumpkinToast-600 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-pumpkinToast-600 group-hover:text-white transition-all duration-500 shadow-sm">
                                    <IconPresentation size={32} stroke={1.5} />
                                </div>
                                <h3 className="text-2xl font-bold text-[#1f0e56] mb-4 font-AndoraModernSerif">Educational Programs</h3>
                                <p className="text-gray-600 leading-relaxed">
                                    Offering offline and online classes, seminars, and basic discussion groups for the common man.
                                </p>
                            </div>
                            <div className="absolute bottom-0 left-0 h-1.5 w-0 bg-pumpkinToast-600 group-hover:w-full transition-all duration-700" />
                        </div>

                        {/* 03: Publications */}
                        <div className="group relative bg-white p-10 rounded-[2.5rem] shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-3 transition-all duration-500 overflow-hidden">
                            <div className="absolute top-0 right-0 p-8 opacity-[0.03] group-hover:opacity-[0.07] transition-opacity">
                                <span className="text-9xl font-black font-AndoraModernSerif">03</span>
                            </div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 bg-green-50 text-green-600 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-green-600 group-hover:text-white transition-all duration-500 shadow-sm">
                                    <IconBooks size={32} stroke={1.5} />
                                </div>
                                <h3 className="text-2xl font-bold text-[#1f0e56] mb-4 font-AndoraModernSerif">Multilingual Publications</h3>
                                <p className="text-gray-600 leading-relaxed">
                                    Writing and publishing scholarly works in Arabic, English, and Malayalam.
                                </p>
                            </div>
                            <div className="absolute bottom-0 left-0 h-1.5 w-0 bg-green-600 group-hover:w-full transition-all duration-700" />
                        </div>

                        {/* 04: Academic Defense */}
                        <div className="group relative bg-white p-10 rounded-[2.5rem] shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-3 transition-all duration-500 overflow-hidden">
                            <div className="absolute top-0 right-0 p-8 opacity-[0.03] group-hover:opacity-[0.07] transition-opacity">
                                <span className="text-9xl font-black font-AndoraModernSerif">04</span>
                            </div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 bg-purple-50 text-purple-600 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-purple-600 group-hover:text-white transition-all duration-500 shadow-sm">
                                    <IconShieldCheck size={32} stroke={1.5} />
                                </div>
                                <h3 className="text-2xl font-bold text-[#1f0e56] mb-4 font-AndoraModernSerif">Academic Defense</h3>
                                <p className="text-gray-600 leading-relaxed">
                                    Preparing intellectual defenses against Hadith misinterpretations and dispelling contemporary doubts.
                                </p>
                            </div>
                            <div className="absolute bottom-0 left-0 h-1.5 w-0 bg-purple-600 group-hover:w-full transition-all duration-700" />
                        </div>

                        {/* 05: Media Outreach */}
                        <div className="group relative bg-white p-10 rounded-[2.5rem] shadow-xl shadow-gray-200/40 border border-gray-100 hover:-translate-y-3 transition-all duration-500 overflow-hidden md:col-span-2 lg:col-span-1">
                            <div className="absolute top-0 right-0 p-8 opacity-[0.03] group-hover:opacity-[0.07] transition-opacity">
                                <span className="text-9xl font-black font-AndoraModernSerif">05</span>
                            </div>
                            <div className="relative z-10">
                                <div className="w-16 h-16 bg-amber-50 text-amber-600 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-amber-600 group-hover:text-white transition-all duration-500 shadow-sm">
                                    <IconLiveView size={32} stroke={1.5} />
                                </div>
                                <h3 className="text-2xl font-bold text-[#1f0e56] mb-4 font-AndoraModernSerif">Media Outreach</h3>
                                <p className="text-gray-600 leading-relaxed">
                                    Transforming mass media into a powerful platform for authentic Hadith propagation.
                                </p>
                            </div>
                            <div className="absolute bottom-0 left-0 h-1.5 w-0 bg-amber-600 group-hover:w-full transition-all duration-700" />
                        </div>
                    </div>
                </div>


            </div>
            <Footer />
        </div>
    );
}
